import { useApi } from "hooks"
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GAHandler } from "utils/GA";

const useBuyContent = () => {

  const { apiFetch } = useApi()
  const queryClient = useQueryClient()

  const url = `/payments/content`;

  const buyContent = ({ contentId, price }) => {
    return apiFetch({
      url,
      method:'POST',
      data: {
        contentId,
        price: parseFloat(price)
      }
    })
      .then(() => {
        GAHandler('content_buyed');
        queryClient.invalidateQueries('purchases')
        queryClient.invalidateQueries('balance')
      })
  }

  const {
    mutateAsync,
    ...rest
  } = useMutation(buyContent)

  return {
    buyContent: mutateAsync,
    ...rest,
  }
}

export default useBuyContent;